import $ from "cash-dom";

//frontend modules
import Xhr from './xhr.js'
import Nav from './nav.js'
import Fold from './fold.js'
import Tabs from './tabs.js'
import Form from './form.js'
import Glow from './glow.js'
import Video from './video.js'
import Slides from './slides.js'
import Filter from './filter.js'
import Fa from './fontawesome.js' 
import Contact from './contact.js'
import Gallery from './gallery.js'
import BlockBg from './blockbg.js'
import BlockFade from './blockfade.js'
import Animation from './animation.js'
import Audiolink from './audiolink.js'
import Layerlink from './layerlink.js'
import BlockArrow from './blockarrow.js'
import BlockBgFade from './blockbgfade.js'
import audioplayer from './audioplayer.js'
import Scrollfocus from './scrollfocus.js'
import FilterEvents from './filterevents.js'

const mods = [
    Animation, Audiolink, BlockArrow, BlockBg, BlockBgFade, BlockFade, Contact, Filter, Fa, Fold, Form, 
    FilterEvents, Gallery, Glow, Layerlink, Nav, Scrollfocus, Slides, Tabs, Video, Xhr
];


export function initModules($parent) {

    const moditems = [];

    $parent
        .find('[data-module]')
        .each(collectModules);

    if($parent.data('module')) collectModules.call($parent[0]);

    function collectModules() {
        const modules = $(this).data("module").split(',');
        modules.forEach((modname) => {
            moditems.push({
                node: this,
                module: modname.trim()
            });
        });
    }

    moditems.forEach((moditem) => {
        initModule(moditem);
    })

    $(window).trigger('modsloaded');
}


function initModule(moditem) {

    const m = mods.filter(el => el.name === moditem.module).shift();
    
    if(m) {
        //console.log('initModule', moditem.node, m);
        new m(moditem.node);
    } else {
        console.log('module not found: ', moditem);
    }
}